import './index.scss'
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import MenuIcon from '@mui/icons-material/Menu'
import Popover from '@mui/material/Popover'
import Typography from '@mui/material/Typography'
import { useState } from 'react'
import { Link } from 'react-router-dom'
import ThemeToggle from '../themeToggle'

type Props = {
  onToggleSideNav?: () => void,
}

const TopNav = ({ onToggleSideNav }: Props) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const names = sessionStorage.getItem('username')
  const role = sessionStorage.getItem('role')?.replaceAll('"', '')

  return(
    <div className='notification-profile-container'>
      <button className='menu-trigger' onClick={onToggleSideNav} aria-label='Open side navigation'>
        <MenuIcon />
      </button>
      <div className='top-nav-actions'>
        <ThemeToggle />
        <div>
          <NotificationsNoneIcon/>
        </div>
        <button className='profile-ctn' aria-describedby={id}  onClick={handleClick}>
          <div className='profile-pic' aria-hidden='true'>
            {(names || '?').trim().charAt(0).toUpperCase() || '?'}
          </div>
          <div className='name-ctn'>
            <div className='name'>
              <span className='key'>{names}</span>
              <span className='value'>{role}</span>
            </div>
            <KeyboardArrowDownIcon/>
          </div>
        </button>
      </div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
      >
        <Typography sx={{ px: 10, py:2 }} >
          <Link to="/login" onClick={() => sessionStorage.clear()} style={{textDecoration: 'none'}}>Logout</Link>
        </Typography>
      </Popover>
    </div>
  )
}

export default TopNav